// FAQ Akkordion
let faq = document.getElementById('faq');

if(faq) {
    let faqs = document.querySelectorAll('.faq')
    let vernetzungHeadings = []
    let faqGrid = document.getElementById('faq-grid')

    faqs.forEach((faq) => {
        
        //FAQ - Ordnung
        let vernetzungHeading = faq.dataset.parent
        console.log(vernetzungHeading);

        if(!(vernetzungHeadings.includes(vernetzungHeading))) {
            vernetzungHeadings.push(vernetzungHeading)
        } 

         //FAQ Akkordion
         function faqAkkordion() {
         let faqButton = faq.querySelectorAll('button').item(0);
         let faqIcon = faqButton.querySelectorAll('svg').item(0);
         let faqAntwort = faq.querySelectorAll('.faq-antwort').item(0);
         faqButton.addEventListener('click', () => {
             faqAntwort.classList.toggle('hidden');
             faqIcon.classList.toggle('rotate')
         })
         }      

         faqAkkordion();
    })
    
    vernetzungHeadings.sort()
    vernetzungHeadings.forEach((vernetzungHeading) => {
        
        // Create DIV
        let faqWrap = document.createElement('div')
        faqWrap.classList.add('faq-kategorie')
        
        // create Heading
        let currentHeading = document.createElement('h3')
        currentHeading.innerHTML = vernetzungHeading
        faqWrap.appendChild(currentHeading)
        
        // Alle FAQs in der Kategorie einfügen
        let currentItems = faqGrid.querySelectorAll(`[data-parent="${vernetzungHeading}"]`)
        currentItems.forEach((currentItem) => {
            faqWrap.appendChild(currentItem);
        })
        
        faqGrid.appendChild(faqWrap)

    })
}